import React from "react";
import ReactModal from "react-modal";
import { Formik } from "formik";
import { Col, Form } from "react-bootstrap";
import "./add-edit-mcc.scss";
import {
    AddUpdateMcc,
    getActiveBanks,
    getBankAddendums,
    ListOfPdfs,
} from "../../../api";
import Loader from "../../loader/loader";
import Cleave from "cleave.js/react";
import SelectDropDown from "../../shared/drop-down/drop-down";
import Select from "react-select";

import * as yup from "yup";
const schema = yup.object({
    mcc: yup.string().trim().required("* This filed is required"),
    category: yup.string().trim().required("* This filed is required"),
    description: yup.string().trim().required("* This filed is required"),
    risk: yup.string().trim().required("* This filed is required"),
});
class AddEditMcc extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEdit: props.selectedMccRecord ? true : false,
            is_submitted: false,
            show_spinner: false,
            errorMessage: "",
            formData: {
                mcc: props.selectedMccRecord ? props.selectedMccRecord.mcc : "",
                category: props.selectedMccRecord
                    ? props.selectedMccRecord.category
                    : "",
                description: props.selectedMccRecord
                    ? props.selectedMccRecord.description
                    : "",
                risk: props.selectedMccRecord
                    ? props.selectedMccRecord.risk
                    : "",
                bank: props.selectedMccRecord
                    ? props.selectedMccRecord.bank
                    : [],
                addendums: props.selectedMccRecord
                    ? props.selectedMccRecord.addendums
                    : [],
            },
            errors: [],
            riskOption: [
                { value: "high_risk", label: "High Risk" },
                { value: "low_risk", label: "Low Risk" },
            ],
            possibleBanks: [{}],
            possibleAddendums: [],
        };
    }
    componentDidMount() {
        ListOfPdfs().then((response) => {
            if (response.data.addendums_names) {
                let tempAddendumsArray = [];
                response.data.addendums_names.map((file_name, key) => {
                    tempAddendumsArray.push({
                        value: file_name,
                        label: file_name,
                    });
                });
                this.setState({
                    possibleAddendums: tempAddendumsArray,
                });
            }
        });
        getActiveBanks().then((response) => {
            if (response.status) {
                let tempBankArray = [];
                response.data.map((item) => {
                    tempBankArray.push({
                        value: item.id,
                        label: item.name,
                    });
                });
                this.setState({
                    possibleBanks: tempBankArray,
                });
            }
        });
    }
    updateChange(evt) {
        const targetName = evt.target.name;
        if (targetName === "") {
            return false;
        }
        let formData = this.state.formData;
        formData[targetName] = evt.target.value.trim();
        this.setState({ formData: formData, errorMessage: "" });
    }

    // add Edit data
    handleAddEditMcc(evt) {
        this.setState({ show_spinner: true });
        const fromData = this.state.formData;

        const postData = {
            id: this.state.isEdit ? this.props.selectedMccRecord.id : null,
            mcc: fromData.mcc,
            category: fromData.category,
            description: fromData.description,
            risk: fromData.risk,
            bank: fromData.bank,
            addendums: fromData.addendums,
        };
        AddUpdateMcc(postData)
            .then((res) => {
                if (res.success) {
                    this.props.handleCloseModel();
                    this.props.GetMccList();
                } else {
                    this.setState({
                        show_spinner: false,
                        errorMessage: "Something wrong please try again.",
                    });
                }
            })
            .catch((err) => {
                if (err.status === 422) {
                    this.setState({
                        show_spinner: false,
                        errorMessage:
                            "Validation error! Please fill all required fields",
                    });
                } else {
                    this.setState({
                        show_spinner: false,
                        errorMessage: "Something wrong please try again.",
                    });
                }
            });
    }
    handleAddendumChange(data) {
        const formData = this.state.formData;
        formData["addendums"] = data;
        this.setState({ formData: formData });
    }
    handleBankChange(data, removedOptions) {
        const formData = this.state.formData;
        let selectedAddendums = formData["addendums"];
        if (removedOptions?.length > 0 && selectedAddendums) {
            let requestData = {};
            requestData.bank_id = removedOptions[0].value;

            getBankAddendums(requestData)
                .then((response) => {
                    let resultArray = selectedAddendums.filter((itemA) => {
                        return !response.data.addendums.some(
                            (itemB) => itemB === itemA.value,
                        );
                    });
                    formData["addendums"] = resultArray;
                    this.setState({ formData: formData });
                })
                .catch((error) => console.log(error));
        }
        formData["bank"] = data;
        this.setState({ formData: formData });
    }

    handleRiskOptionChange(data) {
        const formData = this.state.formData;
        formData["risk"] = data.value;
        this.setState({ formData: formData });
    }

    render() {
        const {
            isEdit,
            show_spinner,
            errorMessage,
            formData,
            errors,
            is_submitted,
        } = this.state;
        return (
            <ReactModal isOpen={this.props.show} className="add-edit-mcc-modal">
                <div className="modal-header">
                    <h4 className="text-left">
                        {isEdit ? "Edit Mcc" : "Add Mcc"}
                    </h4>
                </div>
                <div
                    onClick={() => this.props.handleCloseModel()}
                    className="modal-cancel"
                >
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-body">
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(e) => this.handleAddEditMcc(e)}
                        initialValues={formData}
                        initialErrors={errors}
                        validateOnBlur={false}
                        validateOnChange={is_submitted}
                        validate={(values) => {
                            this.setState({ is_submitted: true });
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                        }) => (
                            <Form
                                id="add-edit-mcc-form"
                                onSubmit={handleSubmit}
                                onChange={(e) => this.updateChange(e)}
                                autoComplete="off"
                            >
                                <Form.Row>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Cleave
                                            options={{
                                                blocks: [8],
                                                numericOnly: true,
                                            }}
                                            placeholder="MCC"
                                            name="mcc"
                                            value={values.mcc}
                                            onChange={handleChange}
                                            type="text"
                                            className={`preapp-form-input form-control`}
                                        />
                                        <label className="modal-lab">MCC</label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.mcc}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="Category"
                                            type="text"
                                            name="category"
                                            value={
                                                values.category
                                                    ? values.category
                                                    : ""
                                            }
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.category &&
                                                !!errors.category
                                            }
                                            isValid={
                                                is_submitted && !errors.category
                                            }
                                            className="preapp-form-input"
                                        />
                                        <label className="modal-lab">
                                            Category
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.category}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="Description"
                                            type="text"
                                            name="description"
                                            value={
                                                values.description
                                                    ? values.description
                                                    : ""
                                            }
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.description &&
                                                !!errors.description
                                            }
                                            isValid={
                                                is_submitted &&
                                                !errors.description
                                            }
                                            className="preapp-form-input"
                                        />
                                        <label className="modal-lab">
                                            Description
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.description}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <SelectDropDown
                                            options={this.state.riskOption}
                                            name="risk"
                                            placeholder="Select Risk"
                                            value={values.risk}
                                            handleChange={(selected) => {
                                                values.risk = selected.value;
                                                this.handleRiskOptionChange(
                                                    selected,
                                                );
                                                errors.risk = "";
                                            }}
                                            touched={touched.risk}
                                            errors={errors.risk}
                                            is_submitted={is_submitted}
                                        />
                                        <label className="modal-lab">
                                            Risk
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.risk}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Select
                                            isMulti
                                            name="bank"
                                            placeholder=""
                                            options={this.state.possibleBanks}
                                            value={values.bank}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            onChange={(selected) => {
                                                let removedOptions =
                                                    values?.bank?.filter(
                                                        (option) =>
                                                            !selected.includes(
                                                                option,
                                                            ),
                                                    );

                                                this.handleBankChange(
                                                    selected,
                                                    removedOptions,
                                                );
                                                errors.bank = "";
                                            }}
                                            touched={touched.bank}
                                            errors={errors.bank}
                                            is_submitted={is_submitted}
                                        />
                                        <label className="modal-lab">
                                            Bank
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.risk}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Select
                                            isMulti
                                            name="addendums"
                                            placeholder=""
                                            options={
                                                this.state.possibleAddendums
                                            }
                                            value={values.addendums}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            onChange={(selected) => {
                                                this.handleAddendumChange(
                                                    selected,
                                                );
                                                errors.addendums = "";
                                            }}
                                            touched={touched.addendums}
                                            errors={errors.addendums}
                                            is_submitted={is_submitted}
                                        />
                                        <label className="modal-lab">
                                            Addendums
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.risk}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        )}
                    </Formik>
                </div>
                {show_spinner ? (
                    <div className="spinner">
                        <Loader />
                    </div>
                ) : (
                    ""
                )}
                <p className="error-message text-center">{errorMessage}</p>
                <div className="modal-footer">
                    <div className="button-twoc">
                        <button
                            form="add-edit-mcc-form"
                            type="submit"
                            className="btn confirm-button"
                        >
                            {" "}
                            {isEdit ? "Update" : "Add"}{" "}
                        </button>
                        <button
                            className="btn cancel-button"
                            onClick={() => this.props.handleCloseModel()}
                        >
                            {" "}
                            Cancel{" "}
                        </button>
                    </div>
                </div>
            </ReactModal>
        );
    }
}

export default AddEditMcc;
